import React, { useRef, useCallback } from 'react'
import { IProps } from './index'
import { useIntersectionContext } from 'marketing-site/src/components/context/IntersectionContext'

export const AnchorSection: React.FC<IProps> = ({ anchorType, anchorId }) => {
  const ref = useRef<HTMLDivElement | null>(null)

  const { itemRefs, updateRefs } = useIntersectionContext()

  const setRef = useCallback(
    (node: HTMLDivElement) => {
      if (node) {
        if (itemRefs.some((itemRef) => itemRef.current?.id === node.id)) {
          return
        }
        ref.current = node
        updateRefs(ref)
      }
    },
    [updateRefs, itemRefs],
  )

  const setAnchorProps = () => {
    switch (anchorType) {
      case 'navigation-marker':
        return {
          id: anchorId,
          className: 'secondary-nav-wrapper__container',
          ref: setRef,
        }
      case 'gradient-marker':
        return {
          id: `${anchorType}-${anchorId}`,
          className: 'anchor-section--gradient-marker',
        }
      default:
        return {}
    }
  }

  const anchorProps = setAnchorProps()

  return (
    <>
      <div {...anchorProps}></div>
      <style jsx>
        {`
          .secondary-nav-wrapper {
            &__container {
              scroll-margin-top: 12rem;
            }
          }
        `}
      </style>
    </>
  )
}
